import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../appState.interface";

export const voucherState = (state: AppStateInterface) => state.voucherState;

export const resultVouchersForLocationPartnerSelector = createSelector(
  voucherState,
  (state) => state.vouchers
);

export const resultLoadingVoucherSelector = createSelector(
  voucherState,
  (state) => state.loading
);